<script setup lang="ts">
import AppToast from '~/components/AppToast.vue'
import { registerToastApi } from '~/composables/useToast'

useTheme().init()

const { origin } = useRequestURL()

useSeoMeta({
    ogImage: `${origin}/assets/img/og-image.png`,
    ogImageWidth: 1024,
    ogImageHeight: 1024,
    twitterCard: 'summary_large_image',
    twitterImage: `${origin}/assets/img/og-image.png`,
})

const toastRef = ref<InstanceType<typeof AppToast> | null>(null)

onMounted(() => {
    if (toastRef.value) {
        registerToastApi(toastRef.value)
    }
})
</script>

<template>
<div>
        <VitePwaManifest />
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>
        <AppToast ref="toastRef" />
    </div>
</template>
